import { Inject, Injectable, Injector }from '@angular/core';


import { MovuRobotics_ds_authentication_ddService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_all_projectsService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_all_warehousesService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_change_shipment_info_by_shipmentId_orderIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_errors_by_transactionService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_license_plate_by_licensePlateIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_license_plate_details_by_licensePlateIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_license_plate_info_for_alter_pallet_hold_by_lotIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_licenseplate_by_lookupCodeService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_licenseplate_by_lookupCode_warehouseNameService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_licenseplate_inventory_by_lotId_locationIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_load_container_by_lookupcodeService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_load_container_details_for_activate_shipment_by_loadContainerIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_location_details_by_locationIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_lot_details_by_lotId_vendorlotIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_material_packagings_lookup_by_materialId_packagingIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_movetask_by_licensePlateIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_movetask_by_taskidService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_orderLineNumber_by_orderId_shipmentId_materialId_lotIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_orderLineNumber_by_shipmentId_materialId_lotIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_orderlines_by_orderIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_pallet_induction_info_by_licensePlateIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_pick_task_by_taskidService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_pick_tasks_by_licensePlateIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_project_by_lookupCodeService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_project_by_projectIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_reasoncodes_by_operationTypeIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_shipment_download_info_by_shipmentId_orderIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_shipment_pick_tasks_by_shipmentId_orderIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_shipment_pick_tasks_by_shipmentId_orderId_v2Service } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_task_details_by_taskIdService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_get_transactions_count_by_groupService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_owners_ddService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_projects_ddService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_warehouse_configuration_gridService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_warehouse_ddService } from './MovuRobotics.datasource.index';
import { MovuRobotics_ds_warehouses_configurations_gridService } from './MovuRobotics.datasource.index';
import { MovuRobotics_get_location_container_by_nameService } from './MovuRobotics.datasource.index';
import { MovuRobotics_get_location_container_by_name_warehouseService } from './MovuRobotics.datasource.index';
import { MovuRobotics_get_warehouse_by_idService } from './MovuRobotics.datasource.index';
import { MovuRobotics_get_warehouse_by_nameService } from './MovuRobotics.datasource.index';

@Injectable({ providedIn: 'root' })
export class MovuRobotics_DatasourceService {

  constructor(
    private injector: Injector
  ) {
  }

  public MovuRobotics: MovuRobotics_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _ds_authentication_dd: MovuRobotics_ds_authentication_ddService;
  public get ds_authentication_dd(): MovuRobotics_ds_authentication_ddService {
    if(!this._ds_authentication_dd) {
      this._ds_authentication_dd = this.injector.get(MovuRobotics_ds_authentication_ddService);
    }
    return this._ds_authentication_dd;
  }
  private _ds_get_all_projects: MovuRobotics_ds_get_all_projectsService;
  public get ds_get_all_projects(): MovuRobotics_ds_get_all_projectsService {
    if(!this._ds_get_all_projects) {
      this._ds_get_all_projects = this.injector.get(MovuRobotics_ds_get_all_projectsService);
    }
    return this._ds_get_all_projects;
  }
  private _ds_get_all_warehouses: MovuRobotics_ds_get_all_warehousesService;
  public get ds_get_all_warehouses(): MovuRobotics_ds_get_all_warehousesService {
    if(!this._ds_get_all_warehouses) {
      this._ds_get_all_warehouses = this.injector.get(MovuRobotics_ds_get_all_warehousesService);
    }
    return this._ds_get_all_warehouses;
  }
  private _ds_get_change_shipment_info_by_shipmentId_orderId: MovuRobotics_ds_get_change_shipment_info_by_shipmentId_orderIdService;
  public get ds_get_change_shipment_info_by_shipmentId_orderId(): MovuRobotics_ds_get_change_shipment_info_by_shipmentId_orderIdService {
    if(!this._ds_get_change_shipment_info_by_shipmentId_orderId) {
      this._ds_get_change_shipment_info_by_shipmentId_orderId = this.injector.get(MovuRobotics_ds_get_change_shipment_info_by_shipmentId_orderIdService);
    }
    return this._ds_get_change_shipment_info_by_shipmentId_orderId;
  }
  private _ds_get_errors_by_transaction: MovuRobotics_ds_get_errors_by_transactionService;
  public get ds_get_errors_by_transaction(): MovuRobotics_ds_get_errors_by_transactionService {
    if(!this._ds_get_errors_by_transaction) {
      this._ds_get_errors_by_transaction = this.injector.get(MovuRobotics_ds_get_errors_by_transactionService);
    }
    return this._ds_get_errors_by_transaction;
  }
  private _ds_get_license_plate_by_licensePlateId: MovuRobotics_ds_get_license_plate_by_licensePlateIdService;
  public get ds_get_license_plate_by_licensePlateId(): MovuRobotics_ds_get_license_plate_by_licensePlateIdService {
    if(!this._ds_get_license_plate_by_licensePlateId) {
      this._ds_get_license_plate_by_licensePlateId = this.injector.get(MovuRobotics_ds_get_license_plate_by_licensePlateIdService);
    }
    return this._ds_get_license_plate_by_licensePlateId;
  }
  private _ds_get_license_plate_details_by_licensePlateId: MovuRobotics_ds_get_license_plate_details_by_licensePlateIdService;
  public get ds_get_license_plate_details_by_licensePlateId(): MovuRobotics_ds_get_license_plate_details_by_licensePlateIdService {
    if(!this._ds_get_license_plate_details_by_licensePlateId) {
      this._ds_get_license_plate_details_by_licensePlateId = this.injector.get(MovuRobotics_ds_get_license_plate_details_by_licensePlateIdService);
    }
    return this._ds_get_license_plate_details_by_licensePlateId;
  }
  private _ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateId: MovuRobotics_ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateIdService;
  public get ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateId(): MovuRobotics_ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateIdService {
    if(!this._ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateId) {
      this._ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateId = this.injector.get(MovuRobotics_ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateIdService);
    }
    return this._ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateId;
  }
  private _ds_get_license_plate_info_for_alter_pallet_hold_by_lotId: MovuRobotics_ds_get_license_plate_info_for_alter_pallet_hold_by_lotIdService;
  public get ds_get_license_plate_info_for_alter_pallet_hold_by_lotId(): MovuRobotics_ds_get_license_plate_info_for_alter_pallet_hold_by_lotIdService {
    if(!this._ds_get_license_plate_info_for_alter_pallet_hold_by_lotId) {
      this._ds_get_license_plate_info_for_alter_pallet_hold_by_lotId = this.injector.get(MovuRobotics_ds_get_license_plate_info_for_alter_pallet_hold_by_lotIdService);
    }
    return this._ds_get_license_plate_info_for_alter_pallet_hold_by_lotId;
  }
  private _ds_get_licenseplate_by_lookupCode: MovuRobotics_ds_get_licenseplate_by_lookupCodeService;
  public get ds_get_licenseplate_by_lookupCode(): MovuRobotics_ds_get_licenseplate_by_lookupCodeService {
    if(!this._ds_get_licenseplate_by_lookupCode) {
      this._ds_get_licenseplate_by_lookupCode = this.injector.get(MovuRobotics_ds_get_licenseplate_by_lookupCodeService);
    }
    return this._ds_get_licenseplate_by_lookupCode;
  }
  private _ds_get_licenseplate_by_lookupCode_warehouseName: MovuRobotics_ds_get_licenseplate_by_lookupCode_warehouseNameService;
  public get ds_get_licenseplate_by_lookupCode_warehouseName(): MovuRobotics_ds_get_licenseplate_by_lookupCode_warehouseNameService {
    if(!this._ds_get_licenseplate_by_lookupCode_warehouseName) {
      this._ds_get_licenseplate_by_lookupCode_warehouseName = this.injector.get(MovuRobotics_ds_get_licenseplate_by_lookupCode_warehouseNameService);
    }
    return this._ds_get_licenseplate_by_lookupCode_warehouseName;
  }
  private _ds_get_licenseplate_inventory_by_lotId_locationId: MovuRobotics_ds_get_licenseplate_inventory_by_lotId_locationIdService;
  public get ds_get_licenseplate_inventory_by_lotId_locationId(): MovuRobotics_ds_get_licenseplate_inventory_by_lotId_locationIdService {
    if(!this._ds_get_licenseplate_inventory_by_lotId_locationId) {
      this._ds_get_licenseplate_inventory_by_lotId_locationId = this.injector.get(MovuRobotics_ds_get_licenseplate_inventory_by_lotId_locationIdService);
    }
    return this._ds_get_licenseplate_inventory_by_lotId_locationId;
  }
  private _ds_get_load_container_by_lookupcode: MovuRobotics_ds_get_load_container_by_lookupcodeService;
  public get ds_get_load_container_by_lookupcode(): MovuRobotics_ds_get_load_container_by_lookupcodeService {
    if(!this._ds_get_load_container_by_lookupcode) {
      this._ds_get_load_container_by_lookupcode = this.injector.get(MovuRobotics_ds_get_load_container_by_lookupcodeService);
    }
    return this._ds_get_load_container_by_lookupcode;
  }
  private _ds_get_load_container_details_for_activate_shipment_by_loadContainerId: MovuRobotics_ds_get_load_container_details_for_activate_shipment_by_loadContainerIdService;
  public get ds_get_load_container_details_for_activate_shipment_by_loadContainerId(): MovuRobotics_ds_get_load_container_details_for_activate_shipment_by_loadContainerIdService {
    if(!this._ds_get_load_container_details_for_activate_shipment_by_loadContainerId) {
      this._ds_get_load_container_details_for_activate_shipment_by_loadContainerId = this.injector.get(MovuRobotics_ds_get_load_container_details_for_activate_shipment_by_loadContainerIdService);
    }
    return this._ds_get_load_container_details_for_activate_shipment_by_loadContainerId;
  }
  private _ds_get_location_details_by_locationId: MovuRobotics_ds_get_location_details_by_locationIdService;
  public get ds_get_location_details_by_locationId(): MovuRobotics_ds_get_location_details_by_locationIdService {
    if(!this._ds_get_location_details_by_locationId) {
      this._ds_get_location_details_by_locationId = this.injector.get(MovuRobotics_ds_get_location_details_by_locationIdService);
    }
    return this._ds_get_location_details_by_locationId;
  }
  private _ds_get_lot_details_by_lotId_vendorlotId: MovuRobotics_ds_get_lot_details_by_lotId_vendorlotIdService;
  public get ds_get_lot_details_by_lotId_vendorlotId(): MovuRobotics_ds_get_lot_details_by_lotId_vendorlotIdService {
    if(!this._ds_get_lot_details_by_lotId_vendorlotId) {
      this._ds_get_lot_details_by_lotId_vendorlotId = this.injector.get(MovuRobotics_ds_get_lot_details_by_lotId_vendorlotIdService);
    }
    return this._ds_get_lot_details_by_lotId_vendorlotId;
  }
  private _ds_get_material_packagings_lookup_by_materialId_packagingId: MovuRobotics_ds_get_material_packagings_lookup_by_materialId_packagingIdService;
  public get ds_get_material_packagings_lookup_by_materialId_packagingId(): MovuRobotics_ds_get_material_packagings_lookup_by_materialId_packagingIdService {
    if(!this._ds_get_material_packagings_lookup_by_materialId_packagingId) {
      this._ds_get_material_packagings_lookup_by_materialId_packagingId = this.injector.get(MovuRobotics_ds_get_material_packagings_lookup_by_materialId_packagingIdService);
    }
    return this._ds_get_material_packagings_lookup_by_materialId_packagingId;
  }
  private _ds_get_movetask_by_licensePlateId: MovuRobotics_ds_get_movetask_by_licensePlateIdService;
  public get ds_get_movetask_by_licensePlateId(): MovuRobotics_ds_get_movetask_by_licensePlateIdService {
    if(!this._ds_get_movetask_by_licensePlateId) {
      this._ds_get_movetask_by_licensePlateId = this.injector.get(MovuRobotics_ds_get_movetask_by_licensePlateIdService);
    }
    return this._ds_get_movetask_by_licensePlateId;
  }
  private _ds_get_movetask_by_taskid: MovuRobotics_ds_get_movetask_by_taskidService;
  public get ds_get_movetask_by_taskid(): MovuRobotics_ds_get_movetask_by_taskidService {
    if(!this._ds_get_movetask_by_taskid) {
      this._ds_get_movetask_by_taskid = this.injector.get(MovuRobotics_ds_get_movetask_by_taskidService);
    }
    return this._ds_get_movetask_by_taskid;
  }
  private _ds_get_orderLineNumber_by_orderId_shipmentId_materialId_lotId: MovuRobotics_ds_get_orderLineNumber_by_orderId_shipmentId_materialId_lotIdService;
  public get ds_get_orderLineNumber_by_orderId_shipmentId_materialId_lotId(): MovuRobotics_ds_get_orderLineNumber_by_orderId_shipmentId_materialId_lotIdService {
    if(!this._ds_get_orderLineNumber_by_orderId_shipmentId_materialId_lotId) {
      this._ds_get_orderLineNumber_by_orderId_shipmentId_materialId_lotId = this.injector.get(MovuRobotics_ds_get_orderLineNumber_by_orderId_shipmentId_materialId_lotIdService);
    }
    return this._ds_get_orderLineNumber_by_orderId_shipmentId_materialId_lotId;
  }
  private _ds_get_orderLineNumber_by_shipmentId_materialId_lotId: MovuRobotics_ds_get_orderLineNumber_by_shipmentId_materialId_lotIdService;
  public get ds_get_orderLineNumber_by_shipmentId_materialId_lotId(): MovuRobotics_ds_get_orderLineNumber_by_shipmentId_materialId_lotIdService {
    if(!this._ds_get_orderLineNumber_by_shipmentId_materialId_lotId) {
      this._ds_get_orderLineNumber_by_shipmentId_materialId_lotId = this.injector.get(MovuRobotics_ds_get_orderLineNumber_by_shipmentId_materialId_lotIdService);
    }
    return this._ds_get_orderLineNumber_by_shipmentId_materialId_lotId;
  }
  private _ds_get_orderlines_by_orderId: MovuRobotics_ds_get_orderlines_by_orderIdService;
  public get ds_get_orderlines_by_orderId(): MovuRobotics_ds_get_orderlines_by_orderIdService {
    if(!this._ds_get_orderlines_by_orderId) {
      this._ds_get_orderlines_by_orderId = this.injector.get(MovuRobotics_ds_get_orderlines_by_orderIdService);
    }
    return this._ds_get_orderlines_by_orderId;
  }
  private _ds_get_pallet_induction_info_by_licensePlateId: MovuRobotics_ds_get_pallet_induction_info_by_licensePlateIdService;
  public get ds_get_pallet_induction_info_by_licensePlateId(): MovuRobotics_ds_get_pallet_induction_info_by_licensePlateIdService {
    if(!this._ds_get_pallet_induction_info_by_licensePlateId) {
      this._ds_get_pallet_induction_info_by_licensePlateId = this.injector.get(MovuRobotics_ds_get_pallet_induction_info_by_licensePlateIdService);
    }
    return this._ds_get_pallet_induction_info_by_licensePlateId;
  }
  private _ds_get_pick_task_by_taskid: MovuRobotics_ds_get_pick_task_by_taskidService;
  public get ds_get_pick_task_by_taskid(): MovuRobotics_ds_get_pick_task_by_taskidService {
    if(!this._ds_get_pick_task_by_taskid) {
      this._ds_get_pick_task_by_taskid = this.injector.get(MovuRobotics_ds_get_pick_task_by_taskidService);
    }
    return this._ds_get_pick_task_by_taskid;
  }
  private _ds_get_pick_tasks_by_licensePlateId: MovuRobotics_ds_get_pick_tasks_by_licensePlateIdService;
  public get ds_get_pick_tasks_by_licensePlateId(): MovuRobotics_ds_get_pick_tasks_by_licensePlateIdService {
    if(!this._ds_get_pick_tasks_by_licensePlateId) {
      this._ds_get_pick_tasks_by_licensePlateId = this.injector.get(MovuRobotics_ds_get_pick_tasks_by_licensePlateIdService);
    }
    return this._ds_get_pick_tasks_by_licensePlateId;
  }
  private _ds_get_project_by_lookupCode: MovuRobotics_ds_get_project_by_lookupCodeService;
  public get ds_get_project_by_lookupCode(): MovuRobotics_ds_get_project_by_lookupCodeService {
    if(!this._ds_get_project_by_lookupCode) {
      this._ds_get_project_by_lookupCode = this.injector.get(MovuRobotics_ds_get_project_by_lookupCodeService);
    }
    return this._ds_get_project_by_lookupCode;
  }
  private _ds_get_project_by_projectId: MovuRobotics_ds_get_project_by_projectIdService;
  public get ds_get_project_by_projectId(): MovuRobotics_ds_get_project_by_projectIdService {
    if(!this._ds_get_project_by_projectId) {
      this._ds_get_project_by_projectId = this.injector.get(MovuRobotics_ds_get_project_by_projectIdService);
    }
    return this._ds_get_project_by_projectId;
  }
  private _ds_get_reasoncodes_by_operationTypeId: MovuRobotics_ds_get_reasoncodes_by_operationTypeIdService;
  public get ds_get_reasoncodes_by_operationTypeId(): MovuRobotics_ds_get_reasoncodes_by_operationTypeIdService {
    if(!this._ds_get_reasoncodes_by_operationTypeId) {
      this._ds_get_reasoncodes_by_operationTypeId = this.injector.get(MovuRobotics_ds_get_reasoncodes_by_operationTypeIdService);
    }
    return this._ds_get_reasoncodes_by_operationTypeId;
  }
  private _ds_get_shipment_download_info_by_shipmentId_orderId: MovuRobotics_ds_get_shipment_download_info_by_shipmentId_orderIdService;
  public get ds_get_shipment_download_info_by_shipmentId_orderId(): MovuRobotics_ds_get_shipment_download_info_by_shipmentId_orderIdService {
    if(!this._ds_get_shipment_download_info_by_shipmentId_orderId) {
      this._ds_get_shipment_download_info_by_shipmentId_orderId = this.injector.get(MovuRobotics_ds_get_shipment_download_info_by_shipmentId_orderIdService);
    }
    return this._ds_get_shipment_download_info_by_shipmentId_orderId;
  }
  private _ds_get_shipment_pick_tasks_by_shipmentId_orderId: MovuRobotics_ds_get_shipment_pick_tasks_by_shipmentId_orderIdService;
  public get ds_get_shipment_pick_tasks_by_shipmentId_orderId(): MovuRobotics_ds_get_shipment_pick_tasks_by_shipmentId_orderIdService {
    if(!this._ds_get_shipment_pick_tasks_by_shipmentId_orderId) {
      this._ds_get_shipment_pick_tasks_by_shipmentId_orderId = this.injector.get(MovuRobotics_ds_get_shipment_pick_tasks_by_shipmentId_orderIdService);
    }
    return this._ds_get_shipment_pick_tasks_by_shipmentId_orderId;
  }
  private _ds_get_shipment_pick_tasks_by_shipmentId_orderId_v2: MovuRobotics_ds_get_shipment_pick_tasks_by_shipmentId_orderId_v2Service;
  public get ds_get_shipment_pick_tasks_by_shipmentId_orderId_v2(): MovuRobotics_ds_get_shipment_pick_tasks_by_shipmentId_orderId_v2Service {
    if(!this._ds_get_shipment_pick_tasks_by_shipmentId_orderId_v2) {
      this._ds_get_shipment_pick_tasks_by_shipmentId_orderId_v2 = this.injector.get(MovuRobotics_ds_get_shipment_pick_tasks_by_shipmentId_orderId_v2Service);
    }
    return this._ds_get_shipment_pick_tasks_by_shipmentId_orderId_v2;
  }
  private _ds_get_task_details_by_taskId: MovuRobotics_ds_get_task_details_by_taskIdService;
  public get ds_get_task_details_by_taskId(): MovuRobotics_ds_get_task_details_by_taskIdService {
    if(!this._ds_get_task_details_by_taskId) {
      this._ds_get_task_details_by_taskId = this.injector.get(MovuRobotics_ds_get_task_details_by_taskIdService);
    }
    return this._ds_get_task_details_by_taskId;
  }
  private _ds_get_transactions_count_by_group: MovuRobotics_ds_get_transactions_count_by_groupService;
  public get ds_get_transactions_count_by_group(): MovuRobotics_ds_get_transactions_count_by_groupService {
    if(!this._ds_get_transactions_count_by_group) {
      this._ds_get_transactions_count_by_group = this.injector.get(MovuRobotics_ds_get_transactions_count_by_groupService);
    }
    return this._ds_get_transactions_count_by_group;
  }
  private _ds_owners_dd: MovuRobotics_ds_owners_ddService;
  public get ds_owners_dd(): MovuRobotics_ds_owners_ddService {
    if(!this._ds_owners_dd) {
      this._ds_owners_dd = this.injector.get(MovuRobotics_ds_owners_ddService);
    }
    return this._ds_owners_dd;
  }
  private _ds_projects_dd: MovuRobotics_ds_projects_ddService;
  public get ds_projects_dd(): MovuRobotics_ds_projects_ddService {
    if(!this._ds_projects_dd) {
      this._ds_projects_dd = this.injector.get(MovuRobotics_ds_projects_ddService);
    }
    return this._ds_projects_dd;
  }
  private _ds_warehouse_configuration_grid: MovuRobotics_ds_warehouse_configuration_gridService;
  public get ds_warehouse_configuration_grid(): MovuRobotics_ds_warehouse_configuration_gridService {
    if(!this._ds_warehouse_configuration_grid) {
      this._ds_warehouse_configuration_grid = this.injector.get(MovuRobotics_ds_warehouse_configuration_gridService);
    }
    return this._ds_warehouse_configuration_grid;
  }
  private _ds_warehouse_dd: MovuRobotics_ds_warehouse_ddService;
  public get ds_warehouse_dd(): MovuRobotics_ds_warehouse_ddService {
    if(!this._ds_warehouse_dd) {
      this._ds_warehouse_dd = this.injector.get(MovuRobotics_ds_warehouse_ddService);
    }
    return this._ds_warehouse_dd;
  }
  private _ds_warehouses_configurations_grid: MovuRobotics_ds_warehouses_configurations_gridService;
  public get ds_warehouses_configurations_grid(): MovuRobotics_ds_warehouses_configurations_gridService {
    if(!this._ds_warehouses_configurations_grid) {
      this._ds_warehouses_configurations_grid = this.injector.get(MovuRobotics_ds_warehouses_configurations_gridService);
    }
    return this._ds_warehouses_configurations_grid;
  }
  private _get_location_container_by_name: MovuRobotics_get_location_container_by_nameService;
  public get get_location_container_by_name(): MovuRobotics_get_location_container_by_nameService {
    if(!this._get_location_container_by_name) {
      this._get_location_container_by_name = this.injector.get(MovuRobotics_get_location_container_by_nameService);
    }
    return this._get_location_container_by_name;
  }
  private _get_location_container_by_name_warehouse: MovuRobotics_get_location_container_by_name_warehouseService;
  public get get_location_container_by_name_warehouse(): MovuRobotics_get_location_container_by_name_warehouseService {
    if(!this._get_location_container_by_name_warehouse) {
      this._get_location_container_by_name_warehouse = this.injector.get(MovuRobotics_get_location_container_by_name_warehouseService);
    }
    return this._get_location_container_by_name_warehouse;
  }
  private _get_warehouse_by_id: MovuRobotics_get_warehouse_by_idService;
  public get get_warehouse_by_id(): MovuRobotics_get_warehouse_by_idService {
    if(!this._get_warehouse_by_id) {
      this._get_warehouse_by_id = this.injector.get(MovuRobotics_get_warehouse_by_idService);
    }
    return this._get_warehouse_by_id;
  }
  private _get_warehouse_by_name: MovuRobotics_get_warehouse_by_nameService;
  public get get_warehouse_by_name(): MovuRobotics_get_warehouse_by_nameService {
    if(!this._get_warehouse_by_name) {
      this._get_warehouse_by_name = this.injector.get(MovuRobotics_get_warehouse_by_nameService);
    }
    return this._get_warehouse_by_name;
  }
}

